import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

// Controlled, presentational filter: the parent owns the selected tournament and
// the (season-filtered) options. When allIncluded is set, an "All Tournaments"
// option (value 0) is offered — used by the scheduler, not by standings.
class TournamentFilter extends React.Component {
  handleTournamentChange = (selectedOption) => {
    this.props.tournamentSet(selectedOption);
  }

  render() {
    const { tournaments, currentTournament, allIncluded, t_controls } = this.props;
    const tournamentOptions = tournaments.map((s) => ({ value: s.id, label: s.name }));
    if (allIncluded) {
      tournamentOptions.unshift({ value: 0, label: t_controls.all_tournaments });
    }
    return (
      <li style={{width: '200px'}}>
        <Select
          className="select"
          onChange={this.handleTournamentChange}
          options={tournamentOptions}
          value={tournamentOptions.find(opt => opt.value === currentTournament) || null}
          menuPortalTarget={document.body}
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
        />
      </li>
    );
  }
}

TournamentFilter.propTypes = {
  tournaments: PropTypes.array.isRequired,
  tournamentSet: PropTypes.func.isRequired,
  currentTournament: PropTypes.number,
  allIncluded: PropTypes.bool,
  t_controls: PropTypes.object.isRequired,
};

TournamentFilter.defaultProps = {
  allIncluded: false,
};

export default TournamentFilter;
